import React from 'react';

export const attachClasses = (Component, ...attachedClassNames) => ( 
    ({className, children}) => (
        <Component className={`${attachedClassNames.map( name => name + ' ')}${className}`}>{children}</Component>
    )
);